<template>
    <div>
        <b-menu class="appbarvertical" v-show="!isMobile">
            <b-menu-list>
                <b-menu-item  v-for="(item) in filteredMenu" :active="item.expand" :icon="item.icon" :expanded="item.expand" :key="item.category" :class="{'item-color':item.category === 'Emisión'}">
                    <template slot="label" slot-scope="props">
                        {{ item.category }}
                        <b-icon class="is-pulled-right" :icon="props.expanded ? 'menu-down' : 'menu-up'"></b-icon>
                    </template>
                    <b-menu-item v-for="page in item.pages" :disabled="!hasAccess(page.roles)" tag="router-link" :icon="page.icon" :label="page.name" :to="page.path" :key="page.name"></b-menu-item>
                </b-menu-item>
                <b-menu-item v-if="hasAccessSAdmin()" tag="router-link" icon="user" label="Super admin" to="/admin/superadmin" key="/sadmin"></b-menu-item>


                        <!--<p  class="menu-label has-text-weight-bold"
                            :key="item.category">
                            {{ item.category }}
                        </p>-->
                        <!--<ul
                            class="menu-list"
                            :key="i"
                            style="margin-bottom: 2.5rem;">
                            <li v-if="hasAccess(page.roles)" v-for="page in item.pages" :key="page.name">
                                <router-link v-if="page.name" :to="page.path">
                                    <span class="menu-text">{{ page.name }}</span>
                                </router-link>

                                    submenu -->
                                <!--<template v-else>
                                    <a role="button" @click="toggle">
                                        <b-icon
                                            icon="chevron-right"
                                            size="is-small"
                                            class="chevron-icon"
                                            :custom-class="isExpanded ? 'mdi-rotate-90' : ''"
                                        />
                                        <span class="menu-text">{{ page.category }}</span>
                                    </a>
                                    <ul :class="{ 'is-active': isExpanded }">
                                        <li
                                            v-for="page in page.pages"
                                            :key="page.name">
                                            <router-link :to="page.path">
                                                <span class="menu-text">{{ page.name }}</span>
                                                <b-tag v-if="page.isNew" type="is-success">New!</b-tag>
                                                <b-tag v-if="page.isUpdated" type="is-info">Updated</b-tag>
                                            </router-link>
                                        </li>
                                    </ul>
                                </template>
                            </li>
                        </ul>-->

            </b-menu-list>
        </b-menu>
        <b-button type="is-text" @click="showSideBar()" size="is-medium">
            <b-icon icon="menu" type="is-white"></b-icon>
        </b-button>
        <div v-show="isMobile">
            <b-sidebar
                type="is-light"
                :fullheight=true
                :fullwidth=false
                :overlay=true
                :right=false
                :open="open"
                @update:open="open = $event"
            >      
                <div style="padding: 10px;">
                    <div style="display: flex; margin-bottom: 0;">
                        <div>
                            <b-button type="is-text" @click="closeSideBar()" size="is-medium">
                                <b-icon icon="menu" type="is-black"></b-icon>
                            </b-button>
                        </div>
                        <div>
                            <router-link style="margin: 0 auto;"
                                to="/"
                                class="navbar-item"
                                active-class="">
                            <img
                                :src="imagen"
                                alt="CERTIFAKT">
                            </router-link>
                        </div>
                    </div>
                    <div style="display: flex;">
                        <b-menu class="appbarvertical">
                            <b-menu-list>
                                <b-menu-item v-for="(item) in filteredMenu" :active="item.expand" :icon="item.icon" :expanded="item.expand" :key="item.category" :class="{'item-color':item.category === 'Emisión'}"">
                                    <template slot="label" slot-scope="props">
                                        {{ item.category }}
                                        <b-icon class="is-pulled-right" :icon="props.expanded ? 'menu-down' : 'menu-up'"></b-icon>
                                    </template>
                                    <b-menu-item @click.native="closeSideBar" v-for="page in item.pages" :disabled="!hasAccess(page.roles)" tag="router-link" :icon="page.icon" :label="page.name" :to="page.path" :key="page.name"></b-menu-item>
                                </b-menu-item>
                                <b-menu-item v-if="hasAccessSAdmin()" tag="router-link" icon="user" label="Super admin" to="/admin/superadmin" key="/sadmin"></b-menu-item>
                            </b-menu-list>
                        </b-menu>
                    </div>
                </div>
            </b-sidebar>
        </div>
    </div>
    
</template>

<script>
  import {mapGetters} from 'vuex'

    export default {
        props: {
            data: Array
        },
        data() {
            return {
                open: false,
                isExpanded: true,
                isMobile: false,
            };
        },
        computed:{
          ...mapGetters({'user':'auth/getUser'}),
          ...mapGetters({'getCompany':'auth/getCompany'}),
          typeUser(){
            return this.user.typeUser
          },
          filteredMenu() {
            const isCC = this.getCompany.isClientCertifact

            return this.data
                .map(item => {
                    const pages = item.pages.filter(page => {
                        // Filtro por cliente Certifact
                        if (isCC && page.onlyCertifakt) {
                            return false
                        }

                        // Filtro por rol 
                        return this.hasAccess(page.roles)
                        })

                    return {
                        ...item,
                        pages
                    }
                })
                // Ocultar categorías vacías
                .filter(item => item.pages.length > 0)
            },
            imagen(){
                return this.getCompany && this.getCompany.isClientCertifact
                    ? "https://certifakt.s3-us-west-2.amazonaws.com/logo_certifakt_text_2.png"
                    : "https://certifakt.s3-us-west-2.amazonaws.com/logo_certifakt_text.png"
            }
        },
        methods: {
            toggle() {
                this.isExpanded = !this.isExpanded
            },
            hasAccess(roles){
                if(this.user.changePass){
                    return false
                }
                return roles.find(ele=>ele == this.typeUser)
            },
            hasAccessSAdmin(){
                //console.log(this.user)
                return 's-admin' == this.user.userName
            },
            enviar(){
                alert("jgjgj")
            },
            showSideBar() {
                this.open = true;
            },
            closeSideBar() {
                this.open = false;
            },
            checkDevice() {
                this.isMobile = window.innerWidth < 1024; // < 1024px = móvil según Bulma
            },
        },
        mounted() {
            this.checkDevice();
            window.addEventListener('resize', this.checkDevice);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkDevice);
        },
    }
</script>
<style scoped>
.appbarvertical {
    width:250px
}
.item-color{
    background-color: #FFA500;
    /*>a{
        background-color: #FFA500;    
    }*/
}
</style>



// WEBPACK FOOTER //
// TheSidebar.vue?97fbb6a2